import type React from "react";

interface ChevronProps {
  orientation: "down" | "up" | "left" | "right";
}

const rotations = {
  down: 0,
  up: 180,
  left: 90,
  right: -90,
} as const;

export function ChevronIcon({ orientation }: ChevronProps): React.ReactNode {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      className="w-icon-inline shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        className="origin-center transition-transform"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
        transform={`rotate(${rotations[orientation]})`}
      />
    </svg>
  );
}
